export default {"src":"/_next/static/media/Doctor-list.195f22bc.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};